/**
 * Copy and pure decisions for /redefinir-senha. No React.
 *
 * passwordsDisagree — the two strings differ. Empty and empty agree.
 * isExpiredResetToken — the reset call rejected the token itself (HTTP 400).
 * resetFailureMessage — a human sentence for any other failure, never the expired-token sentence.
 */
import { readApiError } from "../../sdk/errors/apiError";

export const RESET_COPY = {
  unequal: "As senhas não são iguais.",
  successTitle: "Senha alterada",
  successBody: "Pronto! Sua nova senha já está valendo.",
  expiredTitle: "Link inválido ou expirado",
  expiredBody: "Este link de redefinição não vale mais. Peça um novo para continuar.",
  askNewLink: "Pedir novo link",
  saving: "Salvando…",
  submit: "Salvar nova senha",
  title: "Criar nova senha",
  subtitle: "Escolha uma senha nova para a sua conta.",
  passwordLabel: "Nova senha",
  confirmLabel: "Confirmar nova senha",
  passwordPlaceholder: "Crie uma senha",
  confirmPlaceholder: "Repita a senha",
  remembered: "Lembrou a senha?",
  enter: "Entrar",
  showPassword: "Mostrar senha",
  hidePassword: "Ocultar senha",
  failed: "Não foi possível salvar a senha agora. Tente de novo.",
} as const;

/** Same accent fold as apiError.ts: NFD, strip marks, lower-case. */
function fold(text: string): string {
  return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

const EXPIRED_TOKEN = "token invalido ou expirado";

/** A line a person can read. Longer than this, or Gin `Key:` noise, stays off the form. */
const SHORT_SENTENCE_MAX = 160;

export function passwordsDisagree(password: string, confirmation: string): boolean {
  return password !== confirmation;
}

export function isExpiredResetToken(error: unknown): boolean {
  const { status, raw } = readApiError(error);
  if (status !== 400) return false;

  const folded = fold(raw);
  if (folded === EXPIRED_TOKEN) return true;
  return folded.includes("token") && (folded.includes("invalido") || folded.includes("expirado"));
}

export function resetFailureMessage(error: unknown): string {
  const text = readApiError(error).raw.trim();
  const folded = fold(text);
  if (
    isExpiredResetToken(error) ||
    folded === EXPIRED_TOKEN ||
    text.length === 0 ||
    text.length > SHORT_SENTENCE_MAX ||
    text.startsWith("Key:")
  ) {
    return RESET_COPY.failed;
  }
  return text;
}
